export default __webpack_public_path__ + "static/media/Bracers of the Ragereaver.5489070f.jpg";